import React, { Component } from 'react';
import './index.scss';
import MediaQuery from 'react-responsive';

class ImageSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeOption: 0
    }
  }
  clickSwitch = (i) => {
    this.setState({
      activeOption: i
    })
  }

  render() {

    const { text_1, text_2, photo, photo_2, content } = this.props;
    return (
      <div className="image-switch">
        <div className="wrap">
          <div className="text" dangerouslySetInnerHTML={{__html: content}}></div>
          <ul className="switch">
            <li className={`option-1 ${this.state.activeOption === 0 ? '-active' : ''}`} onClick={() => this.clickSwitch(0)}>
              <div className="out">
                <div className="in"></div>
              </div>
              <div className="option-text">{text_1}</div>
            </li>
            <li className={`option-2 ${this.state.activeOption === 1 ? '-active' : ''}`} onClick={() =>  this.clickSwitch(1)}>
              <div className="out">
                <div className="in"></div>
              </div>
              <div className="option-text">{text_2}</div>
            </li>
          </ul>
        </div>
        <div className="switch-images">
          <div className={`switch-image image_1 ${this.state.activeOption === 0 ? '-active' : ''}`}>
            <img className="-desktop" src={`/${photo.image_desktop}`} alt=""/>
            <img className="-mobile" src={`/${photo.image_mobile}`} alt=""/>
          </div>
          <div className={`switch-image image_2 ${this.state.activeOption === 1 ? '-active' : ''}`}>
            <img className="-desktop" src={`/${photo_2.image_desktop}`} alt=""/>
            <img className="-mobile" src={`/${photo_2.image_mobile}`} alt=""/>
          </div>
        </div>
      </div>
    )
  }
}

class VideoSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeOption: 0
    }
  }
  clickSwitch = (i) => {
    this.setState({
      activeOption: i
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeOption !== this.state.activeOption) {
      this.playCurrentVideo();
    }
  }

  isPlaying = (v) => {
    return  v.currentTime > 0 && !v.paused && !v.ended && v.readyState > 2
  }

  playCurrentVideo = () => {
    const v1 = document.getElementById(`${this.props.customID}_1`);
    const v2 = document.getElementById(`${this.props.customID}_2`);

    if (this.isPlaying(v1)) {
      v1.pause();
      v1.currentTime = '0';
    }

    if (this.isPlaying(v2)) {
      v2.pause();
      v2.currentTime = '0';
    }

    if (this.state.activeOption === 0) {
      if(v1.readyState === 4) {
        v1.play();
      }
    }
    else {
      if(v2.readyState === 4) {
        v2.play();
      }
    }
  }
  render() {

    const { text_1, text_2, video, video_2, content, customID } = this.props;
    return (
      <div className="image-switch">
        <div className="wrap">
          <div className="text" dangerouslySetInnerHTML={{__html: content}}></div>
          <ul className="switch">
            <li className={`option-1 ${this.state.activeOption === 0 ? '-active' : ''}`} onClick={() => this.clickSwitch(0)}>
              <div className="out">
                <div className="in"></div>
              </div>
              <div className="option-text">{text_1}</div>
            </li>
            <li className={`option-2 ${this.state.activeOption === 1 ? '-active' : ''}`} onClick={() =>  this.clickSwitch(1)}>
              <div className="out">
                <div className="in"></div>
              </div>
              <div className="option-text">{text_2}</div>
            </li>
          </ul>
        </div>
        <div className="switch-images">
          <div className={`switch-image image_1 ${this.state.activeOption === 0 ? '-active' : ''}`}>
            <video className="video" width="100%" id={`${customID}_1`} poster={video.cover_image} autoPlay data-keepplaying playsInline>
              <source data-src={video.webm_url} type="video/webm"/>
              <source data-src={video.mp4_url} type="video/mp4"/>
              Your browser does not support the video tag.
            </video>
          </div>
          <div className={`switch-image image_2 ${this.state.activeOption === 1 ? '-active' : ''}`}>
            <video className="video" width="100%" id={`${customID}_2`} poster={video.cover_image} data-keepplaying playsInline>
              <source data-src={video_2.webm_url} type="video/webm"/>
              <source data-src={video_2.mp4_url} type="video/mp4"/>
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    )
  }
}

class ContentSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourceIsActive: false
    }
  }

  showSource = () => {
    this.setState({
      sourceIsActive: true
    })
  }

  closeSource = () =>  {
    this.setState({
      sourceIsActive: false
    })
  }
  componentDidMount() {

  }
  render() {
    const { title, subtitle, content, source, photo, template, text_1, text_2, photo_2, video, video_2 } = this.props;
    return (
      <div className="content-section">
        <div className="container -horizon-padding">
          <p className="directory">0{subtitle}</p>
          <h2 className="title">{title}</h2>
          {
            template === 'normal' ?
            <div className="content">
              <div className="text" dangerouslySetInnerHTML={{__html: content}}></div>
              <div className="image">
                <MediaQuery minWidth="600px">
                {
                  photo &&
                  <img src={`/${photo.image_desktop}`} alt=""/>
                }
                </MediaQuery>
                <MediaQuery maxWidth="599px">
                {
                  photo &&
                  <img src={`/${photo.image_mobile}`} alt=""/>
                }
                </MediaQuery>
              </div>
            </div>
            :
            template === 'normal_animate' ?
            <div className="content">
              <div className="text" dangerouslySetInnerHTML={{__html: content}}></div>
              <div className="image">
                {
                  video &&
                  <video className="video" width="100%" poster={video.cover_image} autoPlay data-keepplaying playsInline>
                    <source data-src={video.webm_url} type="video/webm"/>
                    <source data-src={video.mp4_url} type="video/mp4"/>
                    Your browser does not support the video tag.
                  </video>
                }
              </div>
            </div>
            :
            template === 'two_photo_toggle' ?
            <div className="content">
              <ImageSwitch text_1={text_1} text_2={text_2} photo={photo} photo_2={photo_2} content={content}/>
            </div>
            :
            template === 'two_video_toggle' ?
            <div className="content">
              <VideoSwitch text_1={text_1} text_2={text_2} video={video} video_2={video_2} content={content} customID={`two_video_toggle_${subtitle}`}/>
            </div>
            :
            <div className=""></div>
          }
          {
            source !== null &&
            <div className="">
              <div className={`open-source ${this.state.sourceIsActive ? '' : '-active'}`} onClick={this.showSource}>source <img src="/content-img/open-source-dots.svg" alt="" className="dots"/></div>
              <div className={`source ${this.state.sourceIsActive ? '-active' : ''}`}>
                <div className="text" dangerouslySetInnerHTML={{__html: source}}></div>
                <img src="/content-img/icon-source-cancel.svg" alt="" className="cancel" onClick={this.closeSource}/>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default ContentSection;



// WEBPACK FOOTER //
// ./src/components/ContentSection/pure.js